export default function ($scope, $rootScope, timetableService, plannerFactory) {
    var vm = this;

    vm.planner = plannerFactory.scaffold();

    function getOnline() {
        let online = [];

        vm.planner.forEach(day => {
            if (day.hours[0].classes.length) {
                online = online.concat(day.hours[0].classes);
            }
        });

        return online.length ? online : undefined;
    }

    timetableService.subscribe($scope, 'plannerChanged',
        function plannerUpdated(e, args) {
            vm.addedToPlanner = args.addedToPlanner;
            vm.onlineClassCount = args.onlineClassCount;
            vm.onlineCourseCount = args.onlineCourseCount;
            vm.planner = args.planner;
            vm.online = getOnline();
        });

    $rootScope.$watch('selectedTerm', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            plannerFactory.getFromLocalStorage();
        }
    }, true);
};